<template>
  <div id="relationship-template" >
    <vs-table
      ref="table"
      noDataText="Nenhum Modelo de Mensagem Cadastrado"
      search
      :data="ruleTemplateData"
      @search="searchFilter"
      @sort="sortFilter" 
      :sst="true"
      :max-items="itemsPerPage"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center ml-4">
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
                text-lg font-medium text-base text-primary border border-solid border-primary" @click.stop="redirectToNew">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>
        </div>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
                  cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">
                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  ruleTemplateData.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : ruleTemplateData.length
                }} of {{ queriedItems }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="channel">Canal</vs-th>
        <vs-th sort-key="relationship_rule_id">Nome da Régua</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in ruleTemplateData">
            <vs-td :title="tr.name" :data="ruleTemplateData[indextr].name">
              <p>
                {{ tr.name }}
              </p>
            </vs-td>
            
            <vs-td :title="tr.channel" :data="ruleTemplateData[indextr].channel">
              <p>
                {{ tr.channel }}
              </p>
            </vs-td>

            <vs-td :title="tr.channel" :data="ruleTemplateData[indextr].relationshipRule.name">
              <p>
                {{ tr.relationshipRule.name }}
              </p>
            </vs-td>

            <vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  v-if="canSee('update')"
                  @click.prevent="redirectToEdit(tr.id)"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                />

                <feather-icon
                  class="ml-2"
                  icon="TrashIcon"
                  v-if="canSee('delete')"
                  @click.prevent="openModalToDelete(tr)"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                />
              </vs-td>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup
      title="Remover Métrica Inteligente"
      :active.sync="openDeletePopUp"
      @close="openDeletePopUp = false"
      class="sizePopup"
    >
      <p>Deseja realmente remover o modelo de mensagem ?</p>

      <div class="w-full d-flex justify-content-flex-end">
        <vs-button color="danger" @click.prevent="remove()">Remover</vs-button>
      </div>
    </vs-popup>
    <div class="mt-3 mr-12">
      <vs-pagination :total="totalPages" v-model="page" />
    </div>
  </div>
</template>
<script>
  import FormPopup from './FormPopup'
  import { hasPermission, formatRouteTenantPath } from '@/utils'
  import requests from '@/http/requests/ruleTemplates'
  import moduleRuleTemplate from '@/store/ruleTemplate/moduleRuleTemplate'

  export default {
    name: 'relationship-templates-list',
    components: {
      FormPopup,
    },
    data() {
      return {
        openDeletePopUp: false,
        selected: null,
        dataSearch: '',
        search: "",
        itemsPerPage: 4,
        currentPage: 1,
        page: 1,
        orderBy: {
          name: 'name',
          type: 'ASC'
        },
      }
    },
    watch: {
      'page'() {
        this.fetchRuleTemplate()
      },
      'itemsPerPage'() {
        this.page = 1
        this.fetchRuleTemplate()
      },
    },
    async mounted(){
      await this.fetchRuleTemplate();
    },
    created () {
      if (!moduleRuleTemplate.isRegistered) {
        this.$store.registerModule('ruleTemplate', moduleRuleTemplate)
        moduleRuleTemplate.isRegistered = true
      }
    },
    computed:{
      totalPages() {
        return this.$store.state.ruleTemplate && this.$store.state.ruleTemplate.ruleTemplateData.total_pages
          ? this.$store.state.ruleTemplate.ruleTemplateData.total_pages
          : 0
      },
      queriedItems() {
        return this.$store.state.ruleTemplate && this.$store.state.ruleTemplate.ruleTemplateData.total_items
            ? this.$store.state.ruleTemplate.ruleTemplateData.total_items
            : 0
      },
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx;
        }

        return 0;
      },
      ruleTemplateData() {
        return this.$store.state.ruleTemplate && this.$store.state.ruleTemplate.ruleTemplateData
          ? this.$store.state.ruleTemplate.ruleTemplateData.items : []
      }
    },
    methods: {
      async fetchRuleTemplate() {
        await this.$store.dispatch("ruleTemplate/fetchPaginated", {
            sortName: this.orderBy.name,
            page: this.page,
            itemsPerPage: this.itemsPerPage,
            type: this.orderBy.type,
            word: this.search
          })
      },
      async searchFilter(searchQuery) {
        this.search = searchQuery;
        this.fetchRuleTemplate();
      },
      async sortFilter(sortName) {
        if (sortName) {
          if (sortName !== this.orderBy.name) {
            this.orderBy.name = sortName;
            this.orderBy.type = 'ASC';
          } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
            this.orderBy.type = 'DESC';
          } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
            this.orderBy.name = 'name';
            this.orderBy.type = 'ASC';
          }
          this.fetchRuleTemplate();
        }
      },
      canSee(action) {
        return hasPermission(`relationship-templates-${action}`)
      },
      redirectToNew() {
        this.$router.push(formatRouteTenantPath('/messaging/relationship-templates/new'))
      },
      redirectToEdit(id) {
        this.$router.push(formatRouteTenantPath('/messaging/relationship-templates/' + id + '/edit'))
      },
      openModalToDelete(selected) {
        this.selected = selected;
        this.openDeletePopUp = true;
      },
      remove() {
        requests.delete(this.selected.id).then(() => {
          this.openDeletePopUp = false;
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'O Modelo de Mensagem foi removida com sucesso'
          });
          this.fetchRuleTemplate();
        }).catch((error) => {
          console.log(error)
        })
      },
    },
    beforeRouteLeave(to, from, next) {
      if (this.openDeletePopUp) {
          this.openDeletePopUp = false;
          setTimeout( ()=> {
          next();
          }, 2);
      }
      else {
          next();
      }
    }
  }
</script>
 
<style lang="scss">

#relationship-template {
  .select {
    padding: 15px; 
    display:flex; 
    background: #fff;
    border-radius:10px; 
    text-align:center;
    flex-direction: column; 
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 0.7rem;
    padding: 0 1rem;

    tr{
      box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
      td{
        padding: 10px;
      }
    }
  }

  .vs-table--thead{
    th {
      
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text{
        text-transform: uppercase;
        font-weight: 600;
        
      }
    }
    tr{
      background: none;
      box-shadow: none;
    }
  }

  .vs-table--pagination {
    justify-content: center;
  }
}


</style>
